<template>
	<div class="personal-wrapper">
		<div class="menu-wrapper">
			<el-menu :default-active="active" class="el-menu-vertical-demo" @select="handleSelect">
			  <el-menu-item index="/personal/profile">
				<i class="iconfont icon-gerenziliao"></i>
				<span slot="title">个人资料</span>
			  </el-menu-item>
			  <el-menu-item index="/personal/account">
				<i class="iconfont icon-shezhi"></i>
				<span slot="title">账号设置</span>
			  </el-menu-item>
			  <el-menu-item index="/personal/identification">
				<i class="iconfont icon-icon_commone_shimingrenzhengmian"></i>
				<span slot="title">认证</span>
			  </el-menu-item>
			  
			  <el-menu-item index="/personal/notice">
				<i class="iconfont icon-xiaoxitongzhitixinglingshenglingdang"></i>
				<span slot="title">消息通知</span>
			  </el-menu-item>
			  <el-menu-item index="/personal/identitySwitch">
				<i class="iconfont icon-qiehuan"></i>
				<span slot="title">身份切换</span>
			  </el-menu-item>
			  <el-menu-item index="/personal/anliManager">
				<i class="iconfont icon-a-ziyuan651"></i>
				<span slot="title">案例管理</span>
			  </el-menu-item>
			</el-menu>
		</div>
		<div class="route-wrapper">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
export default {
    data() {
      return {
        active: '/personal/profile',
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        this.active = key
		this.$router.push({path:key})
      }
    },
	mounted(){
		this.active = this.$route.path
	}
  }
</script>

<style lang="scss" scoped>
.personal-wrapper{
	max-width: 1400px;
	width: 80vw;
	margin: 80px auto;
	padding-top: 20px;
	.menu-wrapper{
		display: inline-block;
		background: #fff;
		border-radius: 10px;
		padding: 10px;
		/deep/.el-menu{
			border: none;
			width: 180px;
			font-size: 18px;
			.el-menu-item.is-active{
				color: #FF842E;
				background-color: rgba(249,249,249,.8);
				border-radius: 8px;
			}
			.el-menu-item i{
				margin-right: 15px;
			}
			.el-menu-item:focus {
			    outline: 0;
			    background-color: rgba(249,249,249,.8);
				border-radius: 5px;
			}
			.el-menu-item:hover {
			    outline: 0;
			    background-color: rgba(249,249,249,.8);
				color: #FF842E !important;
				i{
					color: #FF842E !important;
				}
			}
		}
	}
	.route-wrapper{
		display: inline-block;
		background: #fff;
		border-radius: 10px;
		margin-left: 20px;
		width: calc(100% - 220px);
		min-height: 400px;
		vertical-align: top;
	}
}
</style>